import { Component, OnDestroy, inject, resource } from '@angular/core'
import { RouterLink } from '@angular/router'
import { AppService } from '@/app/shared/services/app.service'
import { UserService } from '@/app/shared/services/user.service'
import { InventoryService } from './inventory.service'

@Component({
  selector: 'app-inventory-banner', imports: [RouterLink],
  template: `@if (active.value(); as row) { <aside role="status" class="ui-panel ui-text-secondary flex flex-wrap items-center gap-2 border-b border-(--ui-border-soft) px-4 py-2 text-sm">
    <span class="material-icons text-base text-amber-600 dark:text-amber-400" aria-hidden="true">pause_circle</span>
    <span>Inventaire « {{ row.name }} » en cours : les mouvements de ce stock sont suspendus.</span>
    <a routerLink="/inventories" class="ui-accent-text font-semibold hover:underline">Consulter l’inventaire</a>
  </aside> }`,
})
export class InventoryBanner implements OnDestroy {
  private readonly app = inject(AppService)
  private readonly user = inject(UserService)
  private readonly api = inject(InventoryService)
  readonly active = resource({
    params: () => ({ id: this.app.stockLocation()?.id, refresh: this.api.changed(),
      allowed: this.user.user()?.roles.some((r) => ['GlobalAdmin', 'GlobalReader', 'CompanyAdmin', 'DivisionAdmin', 'profile_Admin', 'profile_StockManager', 'profile_ProcurementManager', 'profile_CPO', 'profile_InventoryController'].includes(r)) }),
    loader: async ({ params }) => !params.id || !params.allowed ? null
      : (await this.api.list(params.id)).find((r) => r.status === 'Counting' || r.status === 'Submitted') ?? null,
  })
  private readonly timer = setInterval(() => this.active.reload(), 30000)
  ngOnDestroy(): void { clearInterval(this.timer) }
}
